import { COLLAPSE_TABLE_TRANSLATION_KEY, OPEN_TABLE_TRANSLATION_KEY } from './constants'
import type { GetToggleTableButtonLabel } from './types'

export const getToggleTableButtonLabel = ({ open, t, title }: GetToggleTableButtonLabel) => {
  const translationKey = open ? COLLAPSE_TABLE_TRANSLATION_KEY : OPEN_TABLE_TRANSLATION_KEY

  if (title) {
    return `${t(translationKey)}: ${title}`
  }

  return t(translationKey)
}
